import "datatables.net"
import "datatables.net-bs4"
import "datatables.net-buttons"
import "datatables.net-buttons-bs4"
import "datatables.net-buttons/js/buttons.html5"
import "datatables.net-buttons/js/buttons.colVis"
import {handleRowClick, prepareHeader} from "./shared";

/*
    Funkcja przypina dynamicznie Datatables do elementu .dataTable.
    Ustawia na tej tabeli różne początkowe elementy dotyczące wyglądu i komunikacja ajaxowej z backendem.
 */
export function attachDataTablesReady(context, paginationUrl, pageLength) {
    const $context = $(context);
    $context.find('.dataTable').each(function() {
        let dt = $(this).DataTable({
            "pageLength": pageLength,
            order: [[7, 'desc']],
            dom: '<"top">rt<"bottom"flpi><"clear">',
            drawCallback: function(){
                $($('.dataTable')[0]).show();
                $("tr.odd > td:nth-child(2), tr.even > td:nth-child(2)").prepend('<em class="bx bx-plus-circle font-size-16 mr-2"></em>');
            },
            initComplete: function () {
                prepareHeader(this.api(), 2);
                $('td.filterHead:nth-child(2) > input:nth-child(1)').addClass('ajax_search_name');
                $('td.filterHead:nth-child(3) > input:nth-child(1)').addClass('ajax_search_category');
                $('td.filterHead:nth-child(4) > input:nth-child(1)').addClass('ajax_search_author');
                $('td.filterHead:nth-child(5) > input:nth-child(1)').addClass('ajax_search_count_of_complete');
                $('td.filterHead:nth-child(6) > input:nth-child(1)').addClass('ajax_search_tag');
                $('td.filterHead:nth-child(7) > input:nth-child(1)').addClass('ajax_search_created_at');
                $('td.filterHead:nth-child(8) > input:nth-child(1)').addClass('ajax_search_changed_at');
                $('td.filterHead:nth-child(9) > input:nth-child(1)').addClass('ajax_search_changed_by');
                $('.column_search').addClass('form-control').addClass('outline-none').addClass('border-width-zero');
                $('.dataTable > thead:nth-child(1) > tr:nth-child(2) > td:nth-child(10)').css({ 'min-width': '150px', 'max-width': '150px' });
                $('.dataTable > tbody:nth-child(2)').css({'cursor': 'pointer'});
                $('td.sorting_disabled:nth-child(1)').removeClass('sorting_asc');
                $('select.outline-none').addClass('border-width-zero');
                $('[data-toggle="tooltip"]').tooltip({
                    show: { duration: 500 }
                });
            },
            "rowCallback": function( row, data ) {
                handleRowClick(row, dt, data);
            },
            'searching': true,
            "searchCols": [
                null,
                { "data": 'name'},
                { "data": 'category'},
                { "data": 'author' },
                { "data": 'count_of_complete' },
                { "data": 'tag' },
                { "data": "created_at"},
                { "data": "changed_at"},
                { "data": "changed_by"},
                null,
            ],
            'columns': [
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                {"orderable" : false}
            ],
            'paging': true,
            'processing': true,
            'serverSide': true,
            'serverMethod': 'get',
            'lengthMenu': [5, 10, 25, 50],
            'ajax': {
                'url': paginationUrl
            },
            language: {
                paginate: {
                    previous: '<i class="bx bx-chevron-left font-size-16 align-middle mr-2"></i>',
                    next: '<i class="bx bx-chevron-right font-size-16 align-middle mr-2"></i>',
                    first: '<i class="bx bx-first-page font-size-16 align-middle mr-2"></i>',
                    last: '<i class="bx bx-last-page font-size-16 align-middle mr-2"></i>'
                },
                info: "Displaying _START_ - _END_ of _TOTAL_ results",
                infoEmpty: "No entries to show"
            },
            columnDefs: [
                {
                    targets: 'no-sort',
                    orderable: false,
                },
                {
                    targets: 1,
                    "width": "50%"
                },
                {
                    targets: 0,
                    "orderable" : false,
                    render: function (data, type, row, meta) {
                        let token = $('meta[name=csrf-token]').prop('content');
                        let canCreateSurvey = $(document).find('input#canCreateSurvey').val();

                        if (canCreateSurvey) {
                            return `
                            <form class="form-horizontal needs-validation secure-link-component" method="post" novalidate="" autocomplete="off">
                                <input type="hidden" name="_method" value="put">
                                <input type="hidden" name="_token" value="${token}">
                                <a class="sweet-alert-popup secured" data-original-title="Go live" data-alert-id="2"
                                     data-alert-link="" data-alert-title="Launch the survey"
                                     data-alert-text="Are you sure you want to launch the survey?"
                                     data-alert-button="Go live the survey"
                                     data-toggle="tooltip"
                                     data-placement="top"
                                     data-alert-icon="question"
                                     data-alert-confirm-button-text="<i class=&quot;label-icon bx bx-play-circle&quot;></i> Go live"
                                     data-alert-confirm-button-class="btn btn-label btn-success btn-min-width"
                                     data-alert-cancel-button-text="<i class=&quot;label-icon bx bx-arrow-back&quot;></i> Cancel" data-alert-cancel-button-class="btn btn-label btn-primary btn-min-width"
                                     data-alert-show-cancel-button="true" href="/panel/survey/${data}/status/live">
                                    <button class="btn waves-effect btn-label waves-light btn-min-width btn-success" type="button">
                                        <i class="label-icon bx bx-play-circle"></i>
                                        Go live
                                    </button>
                                </a>
                            </form>
                            `;
                        } else {
                            return `
                                <button
                                    class="btn waves-effect btn-label waves-light btn-min-width btn-light btn-outline-dark"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    data-original-title="Suspended"
                                    type="button">
                                    <i class="label-icon bx bx-play-circle"></i>
                                    Go live
                                </button>
                            `
                        }
                    }
                },
                {
                    targets: 9,
                    className: "disabled_details",
                    render: function (data, type, row, meta) {
                        return `
                            <a 
                                href="/panel/survey/${row[0]}/general"
                                class="text-success mr-2" data-toggle="tooltip" data-placement="top"
                                title="Show" data-original-title="Show">
                                <i class="bx bxs-edit font-size-22 disabled_details"></i>
                            </a>
                            <a href="${row[0]}/copy"
                               class="text-primary mr-2 showCopySurveyPopup" data-toggle="tooltip" data-placement="top"
                               title="Copy" data-original-title="Copy">
                               <i class="bx bx-copy font-size-22 disabled_details"></i>
                            </a> 
                            <a href="/panel/survey/ajax/${row[0]}"
                              onclick="event.preventDefault(); handleSweetAlertModal(event, 'DELETE');"
                              data-original-title="Remove"
                              data-alert-id="1"
                              data-alert-link=""
                              data-alert-title="Are you sure?"
                              data-alert-text="You won't be able to revert this!"
                              data-alert-button="Remove Survey"
                              data-toggle="tooltip"
                              data-placement="top"
                              data-alert-icon="question"
                              data-alert-confirm-button-text='<i class="label-icon bx bx-trash"></i> Delete'
                              data-alert-confirm-button-class="btn btn-label btn-danger btn-min-width"
                              data-alert-cancel-button-text='<i class="label-icon bx bx-arrow-back"></i> Cancel'
                              data-alert-cancel-button-class="btn btn-label btn-primary btn-min-width"
                              class="secured text-danger">
                              <i class="bx bx-trash font-size-22 disabled_details"></i>
                            </a>`;
                    }
                }
            ],
        });
    });
    $context.find('.data-table-column-search').on('click', function (e) {
        e.stopPropagation();
    });
}
